import { render, staticRenderFns } from "./HeadlineRelatedTitle.vue?vue&type=template&id=e2db9744"
import script from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
export * from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineRelatedTitle.vue?vue&type=style&index=0&id=e2db9744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports